import { EStudentPaymentStatus } from '@constants';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { EIconType } from '../Icon';

import { IconWrapper, StyledIcon, StyledTag, TextWrapper } from './StudentPaymentStatusTag.styles';

type Props = {
  paymentStatus: EStudentPaymentStatus;
  iconOnly?: boolean;
  onClick?: (paymentStatus: EStudentPaymentStatus) => void;
};

const ICON_SIZE = 12;

export const StudentPaymentStatusTag: React.FC<Props> = ({
  paymentStatus,
  iconOnly = false,
  onClick
}) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  if (!paymentStatus) return null;

  const TAG_INFO: Record<
    EStudentPaymentStatus,
    { color: string; backgroundColor: string; borderColor: string; icon: EIconType }
  > = {
    [EStudentPaymentStatus.PAID]: {
      color: colors.green7,
      backgroundColor: colors.green1,
      borderColor: colors.green4,
      icon: 'Money'
    },
    [EStudentPaymentStatus.DOWNTURN]: {
      color: colors.black7,
      backgroundColor: colors.black2,
      borderColor: colors.black4,
      icon: 'PortOutput'
    },
    [EStudentPaymentStatus.NON_PAYMENT]: {
      color: colors.red7,
      backgroundColor: colors.red2,
      borderColor: colors.red4,
      icon: 'ErrorFilled'
    },
    [EStudentPaymentStatus.FORMER_STUDENT]: {
      color: colors.blue7,
      backgroundColor: colors.blue2,
      borderColor: colors.blue4,
      icon: 'Education'
    }
  };

  const { color, backgroundColor, borderColor, icon } = TAG_INFO[paymentStatus];

  if (iconOnly) {
    return (
      <IconWrapper
        $backgroundColor={backgroundColor}
        $borderColor={borderColor}
        onClick={e => {
          e.stopPropagation();
          onClick?.(paymentStatus);
        }}>
        <StyledIcon $color={color} i={icon} size={ICON_SIZE} />
      </IconWrapper>
    );
  }

  return (
    <StyledTag
      $backgroundColor={backgroundColor}
      $borderColor={borderColor}
      onClick={e => {
        e.stopPropagation();
        onClick?.(paymentStatus);
      }}>
      <StyledIcon $color={color} i={icon} size={ICON_SIZE} />
      <TextWrapper $color={color}>{t(paymentStatus)}</TextWrapper>
    </StyledTag>
  );
};
